import { render, staticRenderFns } from "./m-divider.vue?vue&type=template&id=a3cc0b34&scoped=true&"
import script from "./m-divider.vue?vue&type=script&lang=js&"
export * from "./m-divider.vue?vue&type=script&lang=js&"
import style0 from "./m-divider.vue?vue&type=style&index=0&id=a3cc0b34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cc0b34",
  null
  
)

export default component.exports